<section class="summary" [ngStyle]="overlayStyles" @fadeIn>
  <div class="full-overlay bgc-glass-dark">
    <h1
      ><img
        src="Genesys Logo_Digital-Full Color.png"
        title="Genesys Logo"
        alt="Genesys Logo"
        width="135px"
        height="25px"
    /></h1>
    <p @slideFromRightAndFadeIn>
      We hope you loved your personalized video, {{ userName }}! All links can be accessed here.
    </p>
    <table border="0">
      <tr class="vertical-align">
        <td>
          <ul class="hide-bullets">
            <li @slideFromRightAndFadeIn
              ><b class="brand-primary-navy"
                ><a
                  class="brand-navy-link"
                  href="https://orchestrators.genesys.com"
                  target="_blank"
                  title="Genesys Orchestrators link"
                  >Genesys Orchestrators:</a
                >
              </b>
              <ul>
                <li>
                  <a
                    class="overlay-link"
                    href="https://orchestrators.genesys.com/resources/onboarding?product=genesys-cloud-cx#boost-your-knowledge-webinars"
                    target="_blank"
                    title="Boost Your Knowledge Genesys Orchestrators link"
                    >Boost Your Knowledge</a
                  >
                </li>
              </ul>
            </li>
            <li @slideFromRightAndFadeIn
              ><b class="brand-primary-navy">
                <a
                  class="brand-navy-link"
                  href="https://orchestrators.genesys.com/community?product=genesys-cloud-cx"
                  target="_blank"
                  title="Community Link">
                  Community:</a
                ></b
              >
              <app-community-list [role]="role"></app-community-list>
            </li>
            <li @slideFromRightAndFadeIn
              ><b class="brand-primary-navy">
                <a
                  class="brand-navy-link"
                  href="https://orchestrators.genesys.com/advocacy?product=genesys-cloud-cx"
                  target="_blank"
                  title="Genesys Orchestrators Advocacy link"
                  >Advocacy</a
                ></b
              >
            </li>
          </ul>
        </td>
        <td>
          <ul class="hide-bullets">
            <li @slideFromRightAndFadeIn>
              <a
                class="brand-navy-link"
                href="https://orchestrators.genesys.com/resources/genesys-news-and-events#events"
                target="_blank"
                title="Genesys events link"
                >Genesys events</a
              >
            </li>
            <li @slideFromRightAndFadeIn
              ><b class="brand-primary-navy">
                <a
                  class="brand-navy-link"
                  href="https://beyond.genesys.com"
                  target="_blank"
                  title="Education Learning Link">
                  Education:</a
                ></b
              >
              <app-education-course-list [role]="role"></app-education-course-list>
            </li>
            <li @slideFromRightAndFadeIn
              ><b class="brand-primary-navy">
                <a
                  class="brand-navy-link"
                  href="https://orchestrators.genesys.com/home?product=genesys-cloud-cx"
                  target="_blank"
                  title="AI digital assistant Link">
                  AI digital assistant</a
                ></b
              >
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <p>
            Stay in touch with us at
            <a class="overlay-link" href="mailto:cxspecialist@genesys.com">cxspecialist&#64;genesys.com</a>
          </p>
        </td>
      </tr>
    </table>
    <button @slideFromRightAndFadeIn (click)="replayVideo()"> Replay </button>
  </div>
</section>
